import React from 'react';

import DiamondIcon from '../../../common/svg/collection/diamond.svg';
import OwnerIcon from '../../../common/svg/collection/owner.svg';
import styles from './CollectionAnalyticsCard.module.css';

interface Props {
  supply: number;
  owners: number;
}

export const CollectionAnalyticsCard: React.FC<Props> = ({
  supply,
  owners,
}) => {
  return (
    <div className="flex flex-row justify-center items-center flex-wrap w-96 sm:w-auto mb-5 mt-4">
      <div
        className={`${styles.collectionAnalyticsContainer} text-md font-extrabold rounded-lg flex flex-col justify-center items-center h-20 w-40 mx-1 my-1`}
      >
        <div className="flex justify-center items-center">
          <img src={DiamondIcon} alt="" className="h-4 w-4 mr-1" />
          <div>{supply}</div>
        </div>
        <div className="text-sm font-light">Supply</div>
      </div>
      <div
        className={`${styles.collectionAnalyticsContainer} text-md font-extrabold rounded-lg flex flex-col justify-center items-center h-20 w-40 mx-1 my-1`}
      >
        <div className="flex justify-center items-center">
          <img src={OwnerIcon} alt="" className="h-4 w-4 mr-1" />
          <div>{owners}</div>
        </div>
        <div className="text-sm font-light">Owners</div>
      </div>
    </div>
  );
};
